import Header from "../../layouts/Header";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import PlusIcon from "../../assets/images/Plus.svg";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfimationModal from "../../components/Dailogs/ConfimationModal";
import Pagination from "../../components/Pagination/Pagination";
import smaliIcon from "../../assets/icons/meh.svg";
import { GetAdvicedPurchaseOrderList } from "../../redux/actions/action";

import { PlaceBulkOrder } from "../../redux/actions/action";

const AdvanceItemPurchasing = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData([]);
    dispatch(GetAdvicedPurchaseOrderList(perPage, currentPage + 1));
  }, [currentPage, dispatch, perPage]);

  const cancelButtonClick = () => {
    setShowConfirmationModal(false);
    history.push("/stock");
  };

  const sendAllButtonClick = () => {
    setShowConfirmationModal(false);
    history.push("/add-purchasing-order");
  };

  const purchaseOrder = useSelector(
    (state) => state.user.advicedPurchaseOrderList
  );

  const sendBulkPurchaseOrder = () => {
    const projectid = window.localStorage.getItem("projectid");
    PlaceBulkOrder(projectid).then((o) => {
      setShowConfirmationModal(true);
    });
  };

  useEffect(() => {
    if (purchaseOrder != null) {
      if (purchaseOrder?.status) {
        setTableData(purchaseOrder?.data);
        setTotalPages(purchaseOrder?.totalCount / perPage);
      }
    }
  }, [purchaseOrder]);

  return (
    <>
      <Header
        leftComponent={
          <div className="stock-heading-box">
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}>
              Stock
            </div>
            <div className="confirm-box-title-JIT">
              <div className="opacity-1">
                {" "}
                Purchasing Order - Send to supplier
              </div>
            </div>
          </div>
        }
      />

      <div className="container-fluid add-to-warehouse-main-wrapper">
        <div className="main-wrapper add-to-warehouse-wrapper">
          <div className="table-wrapper">
            <table className="table stock-add-table">
              <thead>
                <tr>
                  <th>Purchase order</th>
                  <th>Supplier</th>
                  <th>Total</th>
                  <th>
                    <div
                      onClick={() => sendBulkPurchaseOrder()}
                      className="d-flex align-items-center gap-3 redirect-link justify-content-center">
                      {tableData && tableData.length > 0 && (
                        <img className="plus-img" src={PlusIcon} alt="plus" />
                      )}
                      <div>Send All</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="border-0">
                {tableData?.map((item, index) => {
                  return (
                    <tr key={`tbl-row-${index}`}>
                      <td>
                        <Link
                          to={{
                            pathname: `/add-purchasing-order/false/${item.supplierId}/${item.productPartId}`,
                          }}
                          className="d-flex  gap-3 redirect-link">
                          <div>{item.purchaseOrder}</div>
                        </Link>
                      </td>
                      <td>{item.supplier}</td>
                      <td>&euro;{item.totalCost}</td>
                      <td>
                        <Link
                          to={{
                            pathname: `/add-purchasing-order/false/${item.supplierId}/${item.productPartId}`,
                          }}
                          className="d-flex  gap-3 redirect-link justify-content-center">
                          <img className="plus-img" src={PlusIcon} alt="plus" />
                          <div>Send to Supplier</div>
                        </Link>
                      </td>
                    </tr>
                  );
                })}
                {!tableData.length > 0 && (
                  <tr style={{ height: "83%" }}>
                    <div
                      className="row container mt-5 pt-5 d-flex position-relative"
                      style={{ left: "27%" }}>
                      <img
                        src={smaliIcon}
                        alt="smali"
                        width={35}
                        height={35}
                        className="mt-5 "
                      />
                      <h6
                        className="mt-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: 400,
                          textAlign: "center",
                          color: "#707070",
                        }}>
                        Sorry.
                        <br /> No results for your criteria.
                        <br /> Try to refine your search or enter a new search.
                      </h6>
                    </div>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* {tableData.length > 0 && <div className="align-text-bottom stock-pagination"> */}
        <div className="align-text-bottom stock-pagination">
          <Pagination
            perPage={perPage}
            setPerPage={setPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
        {/* </div>} */}
      </div>

      <ConfimationModal
        title={""}
        description={
          "All the Purchase Order were created successfully and sent to the supplier by email."
        }
        subDescription={"Do you want to add another Purchase Order?"}
        show={showConfirmationModal}
        cancel={cancelButtonClick}
        submit={sendAllButtonClick}
        cancelLabel={"No"}
        submitLable={"Add"}
      />
    </>
  );
};

export default AdvanceItemPurchasing;
